import React,{useState,useEffect} from 'react'
import EcxDatatable from '../common/datatable/EcxDatatable'
import recallService from '../../services/recalls.service'
import { useNavigate } from 'react-router-dom';

function RecallTable() {
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageNumbers,setPageNumbers] = useState([])
    const [currentItems,setCurrentItems] = useState([])
    const navigate = useNavigate()
    const [recallList,setRecallList] =useState([])
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(()=>{
        getRecallRequest(currentPage,itemsPerPage)
    },[currentPage,itemsPerPage])

    const getRecallRequest = (pageNo,pageSize)=>{
        recallService.getRecalls(pageNo,pageSize)
        .then(res=>{
            setRecallList(res.data.content)
            setCurrentItems(res.data.content)
            let pgNo = []
            for ( let i =1 ; i<= res.data.totalPages;i++){
              pgNo.push(i)
            }
            setPageNumbers(pgNo)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const statusString = ["Pending","In Process","Completed","Failed"]
   

    const handleClick = (id)=>{
        navigate('edit/'+id)
    }
    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value));
        setCurrentPage(0); // Reset to the first page when changing items per page
      };
  return (
  <>
 
<div className='p-2'>
      <div className="d-flex justify-content-between mb-3">
        <div className='d-flex flex-columns align-items-center'>
        <div className='form-group me-2'>
           <select id="itemsPerPage" className="form-select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
            {/* Add more options as needed */}
          </select>
        </div>
       
         </div>
       
        <nav>
          
          <ul className="pagination">
            {pageNumbers.map(number => (
              <li key={number} className={`page-item ${currentPage === number-1 ? 'active' : ''}`}>
                <button className="page-link" onClick={()=>paginate(number-1)}>{number}</button>
              </li>
            ))}
          </ul>
        </nav>
        
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Clinic Name</th>
            <th>Title</th>
           
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item, index) => (
             <React.Fragment key={index}>
            <tr key={index}>
             
              <td><small>{item.id}</small></td>
              <td><span><small>{item.clinicName}</small></span></td>
              <td><small>{item.title}</small></td>
              <td>{statusString[item.status]}</td>
              <td> 
                <button className="btn btn-primary" onClick={()=>handleClick(item.id)}><i className="bi bi-pencil"></i></button>
              </td>
             
            </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <nav>
        <ul className="pagination">
        {pageNumbers.map(number => (
              <li key={number} className={`page-item ${currentPage === number-1 ? 'active' : ''}`}>
                <button className="page-link" onClick={()=>paginate(number-1)}>{number}</button>
              </li>
            ))}
        </ul>
      </nav>
    </div>
  </>
  )
}

export default RecallTable